import React, { useEffect, useState } from 'react'
import Loading from 'components/Loading';
import { toast } from 'react-toastify';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import MissionCategoryTable from './MissionCategoryTable';
import { getMissionCategory } from 'services/mission.routes';

export default function MissionCategory() {
    const [loading, setLoading] = useState(false);
    const [missionCategory, setMissionCategory] = useState([]);

    useEffect(() => {
        setLoading(true);
        getMissionCategory((isOk, data) => {
            setLoading(false);
            if (!isOk) {
                return toast.error(data.message)
            } else {
                setMissionCategory(data);
            }
        })
    }, []);
    return (
        <DashboardLayout>
            <Loading loading={loading} />
            <DashboardNavbar />
            <MissionCategoryTable data={missionCategory} />
        </DashboardLayout>
    )
}
